import React, { useEffect, useState } from 'react';
import { ZapIcon } from 'lucide-react';
const TOTAL_SECONDS = 38 * 60 + 50;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function CountdownBar() {
  const [remaining, setRemaining] = useState<number>(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const units: Array<{
    value: number;
    suffix: string;
  }> = [{
    value: Math.floor(remaining / 3600),
    suffix: 'ore'
  }, {
    value: Math.floor(remaining % 3600 / 60),
    suffix: 'min'
  }, {
    value: remaining % 60,
    suffix: 'sec'
  }];
  return <div className="sticky top-0 z-50 w-full bg-navy text-white" data-id="element-36" data-mp="28g6ws8ktiikw">
      <div className="mx-auto flex max-w-5xl flex-nowrap items-center justify-center gap-x-2 whitespace-nowrap px-3 py-2 text-[9px] font-bold uppercase tracking-[0.1em] sm:px-4 sm:py-2.5 sm:text-[11px] sm:tracking-[0.14em]" data-id="element-37" data-mp="ap4bhyzkezm6">
        <ZapIcon className="h-3 w-3 shrink-0 fill-current sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-38" data-mp="13d92zt2l1swq" />
        <span className="sm:hidden" data-id="element-39" data-mp="18b0tcinkx6yt">Offerta -95% scade tra:</span>
        <span className="hidden sm:inline" data-id="element-40" data-mp="uenm02crely2">
          Offerta di lancio: risparmia il 95% se ordini entro:
        </span>
        <span className="flex items-center gap-1 tabular-nums" aria-live="off" data-id="element-41" data-mp="yf7h70drvfhk">
          {units.map((unit, index) => <span key={unit.suffix} className="flex items-center gap-1" data-id="element-42" data-mp="1m6utodaaeo0b" data-mpi={index}>
              <span className="text-xs font-extrabold tracking-normal sm:text-base" data-id="element-43" data-mp="1r2tks8n02k4f">
                {pad(unit.value)}
              </span>
              <span className="text-[8px] tracking-normal text-white/70 sm:text-[9px]" data-id="element-44" data-mp="1hdjumybpvbiy">
                {unit.suffix}
              </span>
              {index < units.length - 1 && <span className="text-white/50 sm:px-1" data-id="element-45" data-mp="29u2v2k4lhcx2">:</span>}
            </span>)}
        </span>
      </div>
    </div>;
}